import React from 'react';
import { PropTypes } from 'prop-types';
import { ProjectContext } from './ProjectContext';
import Section from '../common/Section';
import ProjectTableRow from './ProjectTableRow';

const ProjectsTable = ({ projects }) => {
  return (
    <Section className="table-content">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>ID</th>
            <th>Name</th>
            <th>Complexity</th>
            <th>Company</th>
            <th>Type</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ProjectContext.Consumer>
            {({ returnPath }) => (
              projects.map(project =>
                <ProjectTableRow
                  key={project.id}
                  project={project}
                  returnPath={returnPath}
                />
              )
            )}
          </ProjectContext.Consumer>
        </tbody>
      </table>
    </Section>
  )
}

ProjectsTable.propTypes = {
  projects: PropTypes.array.isRequired
}

export default ProjectsTable;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectsTable.js